import { ButtonVariant, Button } from '@florencelabs/button';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useAnalytics } from '@provider-directory/components/analytics/analytics-provider.tsx';
import {
  useDecisionTree,
  setSchedulingFlowType,
} from '@provider-directory/contexts/DecisionTreeContext';
import { useSearch } from '@provider-directory/contexts/ProviderSearchContext.tsx';
import type { ConversionContext } from '@provider-directory/lib/analytics/conversions';
import { DecisionTreeMode } from '@provider-directory/models/decision-tree.model';
import type {
  ProviderResource,
  ProvidersSearchCriteria,
} from '@provider-directory/types/providers.contracts';

interface BookAnotherProviderButtonProps
  extends Pick<ConversionContext, 'linkContextPage' | 'linkContextComponent'> {
  provider: ProviderResource;
  onOpenDecisionTree?: () => void;
  variant?: ButtonVariant;
  className?: string;
  searchCriteria?: Partial<ProvidersSearchCriteria>;
}

export const BookAnotherProviderButton = ({
  provider,
  onOpenDecisionTree,
  variant = 'systemOutline',
  searchCriteria,
  linkContextPage,
  linkContextComponent,
}: BookAnotherProviderButtonProps): ReactElement => {
  const { t } = useTranslation();
  const { setMode } = useDecisionTree();
  const { clickedBookAnotherProviderEvent } = useAnalytics();

  const { specialtyNames } = useSearch();
  const handleBookAnotherProvider = (): void => {
    clickedBookAnotherProviderEvent({
      provider,
      searchCriteria: {
        ...searchCriteria,
        specialties: specialtyNames,
      },
      linkContextPage,
      linkContextComponent,
    });
    setSchedulingFlowType('BookAnotherProvider');
    setMode(DecisionTreeMode.RedirectOnRfvSelect);
    onOpenDecisionTree?.();
  };

  return (
    <Button
      variant={variant}
      size={'small'}
      onClick={handleBookAnotherProvider}
      className={'!h-auto w-full !leading-[140%]'}
      testId={`provider-${provider.npi}-book-another-provider-btn`}
    >
      {t('search.bookAnotherProvider')}
    </Button>
  );
};
